<header class="header-container-wrapper">
    <div class="main-header">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-3 col-6 logo">
                    <a href="https://www.bajajcapital.com/">
                        <img src="./assets/images/logo.png" alt="BCL" width="210" />
                    </a>
                </div>
                <div class="col-md-9 col-6 text-right">
                    <a href="#" class="p-0"><img
                        src="./assets/images/connect.png" width="144" alt="icon connect"></a>
                </div>
            </div>
        </div>
    </div>
</header>
